<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="moviesField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeMoviesField] ? 'Exclude' : 'Include')} Movies`"
      :options="movies.data"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      use-input
      input-style="search"
      input-debounce="300"
      clearable
      :rules="[
        val => !!val || 'Field is required'
      ]"
      @filter="filterMovies"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeMoviesField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'

export default {
  name: 'MoviesConditionForm',
  props: {
    conditional: {
      type: Object,
      required: true
    },
    moviesField: {
      type: String,
      default: CONDITION_REQUIREMENTS.MOVIES
    },
    excludeMoviesField: {
      type: String,
      default: CONDITION_REQUIREMENTS.EXCLUDE_MOVIES
    }
  },
  data () {
    return {
      movieSearchString: ''
    }
  },
  models: {
    movies: {
      variables () {
        return {
          searchString: this.movieSearchString,
          orderBy: 'createdAt',
          descending: true,
          limit: 10
        }
      }
    }
  },
  methods: {
    filterMovies (val, update, abort) {
      update(() => {
        this.movieSearchString = val
      })
    }
  }
}

</script>
